import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Retired 2026-09-15 in favour of legacy parity (`/birthday/browse` and siblings).
 *
 * v2 reminder emails sent before that change link here, and those land in inboxes that
 * are read weeks later, so this stays as a permanent redirect rather than being deleted.
 * Search params are carried across — `?reminder_id=` is the whole point of the link.
 */
export const Route = createFileRoute("/cards/browse")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/birthday/browse", search, replace: true });
  },
});
